import { http } from "./api";

/**
 * Fire-and-forget analytics events. Never throws. Silently discards errors so
 * a broken analytics collection can never break the user flow.
 */
export function track(event, props) {
  try {
    http.post("/analytics/event", { event, props: props || {} }).catch(() => {});
  } catch {}
}
